export const TableouterBoxStyle= {
    width: '100%',
    height: '52vh',
    marginTop: "0.6rem"
  }

export const paperStyle={
    // width: "100%",
    // height: '100%',
    border: '1px solid #D9D9D9',
    padding: "1rem",
  }

export const headerBoxStyle = {
    border:"20px  ",
    display: 'flex',
    padding: "0.3rem",
    flexWrap: 'wrap',
  }

export const internalBoxStyle= {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '20%',
    flex: '1 1',
    flexDirection: "row",
    flexWrap: 'wrap'
    // padding: "0.1rem 2rem"
  }
export const typographyStyle= {
    marginLeft: "0.5rem",
    padding:"0.1rem",
    fontSize: "1rem",
    fontWeight: "600"
  }

export const headerCellStyle = {

    padding: '0.2rem 0.5rem 0.2rem 0.5rem', 
    fontSize: "1rem",
    fontWeight: "400",
    textAlign: 'center'
  }  

export const nameTextStyle= {
    fontSize: '0.85rem',
    fontWeight: '600',
    textAlign: 'center'   
}  